<template>
	
<div class="practical">

	<div class="practical-title">{{ section.treatment.more.practical.title }}</div>

	<div class="practical-items">

		<div class="practical-items-item">

			<div class="practical-items-item-head">{{ section.treatment.more.practical.method }}</div>

			<div class="practical-items-item-body" :data-icon="section.treatment[treatment].methodIcon">

				{{ section.treatment[treatment].method }}

				<div class="practical-items-item-body-detail" v-if="section.treatment[treatment].methodText" v-html="section.treatment[treatment].methodText"></div>

			</div>

		</div>

		<div class="practical-items-item">

			<div class="practical-items-item-head">{{ section.treatment.more.practical.frequency }}</div>

			<div class="practical-items-item-body" data-icon="frequency">

				{{ section.treatment[treatment].frequency }}

				<div class="practical-items-item-body-detail" v-if="section.treatment[treatment].frequencyText" v-html="section.treatment[treatment].frequencyText"></div>

			</div>

		</div>

		<div class="practical-items-item">

			<div class="practical-items-item-head">{{ section.treatment.more.practical.duration }}</div>

			<div class="practical-items-item-body" data-icon="duration">

				{{ section.treatment[treatment].duration }}

				<div class="practical-items-item-body-detail" v-if="section.treatment[treatment].durationText" v-html="section.treatment[treatment].durationText"></div>

			</div>

		</div>

	</div>

</div>

</template>

<script>

export default {

	props: ['section', 'treatment'],

}

</script>

<style scoped>

.practical {
	background-color: #fff;
	padding: 32px;
	border-radius: 17px;
	margin-bottom: 16px;
}

.practical-title {
	color: #343434;
	font-size: 24px;
	margin-bottom: 32px;
	font-weight: 600;
}

.practical-items {
	display: flex;
	flex-direction: row;
	width: 100%;
}

.practical-items-item {
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
	width: calc(33.3% - 22px);
}

.practical-items-item:nth-child(2) {
	margin: 0px 32px;
}

.practical-items-item-head {
	background-color: #343434;
	text-align: center;
	color: #fff;
	font-weight: 600;
	font-size: 16px;
	line-height: 48px;
	border-radius: 6px 6px 0px 0px;
}

.practical-items-item-body {
	background-color: #F6F6F6;
	border-radius: 0px 0px 6px 6px;
	padding: 128px 16px 16px 16px;
	font-size: 16px;
	line-height: 20px;
	color: #343434;
	text-align: center;
	font-weight: 600;
	background-position: 50% 16px;
	background-repeat: no-repeat
}

.practical-items-item-body-detail {
	font-size: 14px;
	line-height: 18px;
	font-weight: 300;
	display: block;
	margin-top: 10px;
	padding: 0px 10px;
}

.practical-items-item-body-detail >>> p,
.practical-items-item-body-detail >>> ul {
	margin-bottom: 10px;
}

.practical-items-item-body-detail >>> *:last-child {
	margin-bottom: 0px;
}

.practical-items-item-body-detail >>> i,
.practical-items-item-body-detail >>> em {
	font-style: italic;
}

.practical-items-item-body-detail >>> strong,
.practical-items-item-body-detail >>> b {
	font-weight: 600;
}

.practical-items-item-body-detail >>> ul {
	text-align: left;
	list-style-type: disc;
	list-style-position: outside;
}

.practical-items-item-body-detail >>> li {
	text-align: left;
}

.practical-items-item-body[data-icon="mouth"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.mouth.svg);
}

.practical-items-item-body[data-icon="injection"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.injection.svg);
}

.practical-items-item-body[data-icon="sinjection"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.injection2.svg);
}

.practical-items-item-body[data-icon="frequency"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.frequency.svg);
}

.practical-items-item-body[data-icon="duration"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.duration.svg);
}

.is-patient .practical-items-item-body[data-icon="mouth"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.mouth.patient.svg);
}

.is-patient .practical-items-item-body[data-icon="injection"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.injection.patient.svg);
}

.is-patient .practical-items-item-body[data-icon="sinjection"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.injection2.patient.svg);
}

.is-patient .practical-items-item-body[data-icon="frequency"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.frequency.patient.svg);
}

.is-patient .practical-items-item-body[data-icon="duration"] {
	background-image: url(~@/assets/aid/improve/treatment/more/icon.duration.patient.svg);
}

</style>